import {bindActionCreators} from 'redux'
import {connect} from '../../../../redux/utils'
import {
    getCounters,
    getEntirelyAssignedProjectCounter,
    getEntirelyAssignedTasksCounter,
    getPanelUserFirstName,
    getSearch,
    isSearchOpen,
    getTab,
    selectCustomerEntities,
    selectProjectEntities,
    selectTaskEntities,
    isShowArchivedEntities,
    isNoCptAssignedToUserAtAll,
} from '../selectors'
import {changeWorkAssignmentPanelTab, revokeAllTypeAction, revokeEntitiesAction, setIsShowArchiveEntities, setSearchOpen, setSearchString} from '../actions'
import WorkAssignmentPanelTabContent from './WorkAssignmentPanelTabContent'

export default connect(
    state => ({
        userFirstName: getPanelUserFirstName(state),
        counters: getCounters(state),
        noCptAssignedToUserAtAll: isNoCptAssignedToUserAtAll(state),

        searchString: getSearch(state),
        searchOpen: isSearchOpen(state),

        entirelyAssignedTasksCounter: getEntirelyAssignedTasksCounter(state),
        entirelyAssignedProjectsCounter: getEntirelyAssignedProjectCounter(state),

        customerEntities: selectCustomerEntities(state),
        projectEntities: selectProjectEntities(state),
        taskEntities: selectTaskEntities(state),

        isShowArchiveEntities: isShowArchivedEntities(state),

        openTab: getTab(state),

        // work assignment panel must be without toggle archived entities
        showToggleArchivedButton: false,
    }),
    dispatch => ({
        onEntityRevoked: bindActionCreators(revokeEntitiesAction, dispatch),
        onAllRevoked: bindActionCreators(revokeAllTypeAction, dispatch),
        onSearchChanged: bindActionCreators(setSearchString, dispatch),
        onSearchToggled: bindActionCreators(setSearchOpen, dispatch),

        setIsShowArchiveEntities: bindActionCreators(setIsShowArchiveEntities, dispatch),
    })
)(WorkAssignmentPanelTabContent)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/TabContent.js